import { ISalesSupportActions } from './sales-support-actions.model';
import { User } from './user.model';
import { Transport } from './transport.model';
import { CtaAction } from './cta.action';

export class TransportView extends Transport {
  public salesSupportActionsList?: ISalesSupportActions[] = [];
  public user?: User;
  public customerName?: string;
  public ctaActions?: CtaAction[]; //TODO: Rien a faire ici
  public isOrphan?: boolean; //TODO: A vérifier mais c'est utile uniquement dans QuotationView

  constructor(data: any = {}) {
    super(data);
    this.customerName = data.customerName;
    this.user = data.user;
    this.salesSupportActionsList = data.salesSupportActionsList;
    this.ctaActions = data.ctaActions;
    this.isOrphan = data.isOrphan;
  }
}
